import { render } from "./DashboardContainer.vue?vue&type=template&id=1607691c&scoped=true"
import script from "./DashboardContainer.vue?vue&type=script&lang=js"
export * from "./DashboardContainer.vue?vue&type=script&lang=js"

import "./DashboardContainer.vue?vue&type=style&index=0&id=1607691c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1607691c"]])

export default __exports__